import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    icon: 'ri-computer-line',
    tag: 'Formatação',
    title: 'Formatação de Micros e Notebooks',
    description:
      'Seu computador lento ou com vírus? Fazemos a formatação completa com instalação do sistema operacional, drivers e programas essenciais. Rápido, seguro e como novo!',
    highlights: ['Windows 10/11', 'Instalação de drivers', 'Antivírus incluso'],
    image:
      'https://readdy.ai/api/search-image?query=professional%20technician%20formatting%20laptop%20computer%20in%20clean%20modern%20IT%20workshop%2C%20teal%20and%20dark%20navy%20color%20scheme%2C%20bright%20workspace%20with%20tools%20on%20white%20desk%2C%20high%20quality%20photography%2C%20sharp%20focus&width=1200&height=600&seq=car001&orientation=landscape',
    cta: 'Solicitar Formatação',
    color: '#00c9a7',
  },
  {
    icon: 'ri-cpu-line',
    tag: 'Montagem',
    title: 'Montagem de Computadores Gamers',
    description:
      'Monte o PC dos seus sonhos! Ajudamos você a escolher os melhores componentes dentro do seu orçamento e fazemos a montagem completa com garantia.',
    highlights: ['Consultoria de peças', 'Montagem profissional', 'Teste de estabilidade'],
    image:
      'https://readdy.ai/api/search-image?query=premium%20custom%20gaming%20PC%20build%20with%20RGB%20lighting%20inside%20tempered%20glass%20case%2C%20colorful%20components%20motherboard%20GPU%20RAM%20visible%2C%20dark%20dramatic%20background%20with%20teal%20and%20green%20glow%2C%20professional%20studio%20photography&width=1200&height=600&seq=car002&orientation=landscape',
    cta: 'Montar meu PC',
    color: '#00c9a7',
  },
  {
    icon: 'ri-tools-line',
    tag: 'Manutenção',
    title: 'Limpeza e Manutenção Preventiva',
    description:
      'Computador esquentando demais ou travando? Realizamos limpeza interna completa, troca de pasta térmica e manutenção preventiva para garantir mais vida útil ao seu equipamento.',
    highlights: ['Limpeza interna', 'Troca de pasta térmica', 'Diagnóstico completo'],
    image:
      'https://readdy.ai/api/search-image?query=male%20technician%20sitting%20at%20dark%20repair%20workbench%20carefully%20cleaning%20desktop%20computer%20components%20with%20brush%20and%20compressed%20air%20tools%2C%20dim%20workshop%20with%20focused%20task%20lamp%20illuminating%20work%20area%2C%20dark%20moody%20background%20with%20subtle%20teal%20ambient%20glow%2C%20professional%20IT%20repair%20technician%20at%20work%2C%20cinematic%20wide%20shot%2C%20realistic%20photography&width=1200&height=600&seq=car003c&orientation=landscape',
    cta: 'Agendar Manutenção',
    color: '#00c9a7',
  },
  {
    icon: 'ri-remote-control-line',
    tag: 'Suporte Remoto',
    title: 'Suporte Remoto Rápido e Seguro',
    description:
      'Sem precisar sair de casa! Conectamos remotamente ao seu computador de forma segura para diagnosticar e resolver problemas de software em minutos.',
    highlights: ['Acesso seguro', 'Remoção de vírus', 'Suporte para empresas'],
    image:
      'https://readdy.ai/api/search-image?query=IT%20support%20specialist%20working%20on%20dual%20monitors%20with%20remote%20desktop%20connection%20interface%2C%20professional%20modern%20home%20office%20setup%2C%20teal%20and%20dark%20navy%20color%20scheme%2C%20technology%20concept%2C%20clean%20workspace&width=1200&height=600&seq=car004&orientation=landscape',
    cta: 'Suporte Agora',
    color: '#00c9a7',
  },
  {
    icon: 'ri-install-line',
    tag: 'Instalação',
    title: 'Instalação de Softwares e Sistemas',
    description:
      'Instalamos e configuramos sistemas operacionais, pacote Office, antivírus, drivers e qualquer software que você precisar, de forma rápida e sem dor de cabeça.',
    highlights: ['Windows e Linux', 'Pacote Office', 'Softwares específicos'],
    image:
      'https://readdy.ai/api/search-image?query=software%20installation%20progress%20bar%20on%20modern%20computer%20screen%2C%20professional%20IT%20setup%20environment%2C%20clean%20minimalist%20desk%2C%20teal%20and%20dark%20blue%20interface%20design%2C%20modern%20technology%20workspace%2C%20high%20quality%20photo&width=1200&height=600&seq=car005&orientation=landscape',
    cta: 'Instalar Agora',
    color: '#00c9a7',
  },
  {
    icon: 'ri-briefcase-line',
    tag: 'Consultoria',
    title: 'Consultoria em TI para Empresas',
    description:
      'Soluções tecnológicas sob medida para o seu negócio. Infraestrutura de rede, segurança da informação, escolha de equipamentos e suporte contínuo.',
    highlights: ['Redes e infraestrutura', 'Segurança da informação', 'Suporte contínuo'],
    image:
      'https://readdy.ai/api/search-image?query=dark%20dramatic%20server%20room%20interior%20with%20rows%20of%20illuminated%20rack%20servers%20glowing%20teal%20and%20blue%20LED%20lights%2C%20deep%20shadows%20on%20metallic%20surfaces%2C%20moody%20cinematic%20atmosphere%2C%20ultra%20wide%20angle%20shot%2C%20professional%20data%20center%20photography%2C%20high%20resolution&width=1200&height=600&seq=car006b&orientation=landscape',
    cta: 'Falar com Consultor',
    color: '#00c9a7',
  },
  {
    icon: 'ri-code-s-slash-line',
    tag: 'Criação de Sites',
    title: 'Sites Personalizados para o seu Negócio',
    description:
      'Criamos sites modernos, responsivos e otimizados para o Google. Desenvolvemos a presença digital ideal para sua empresa crescer online.',
    highlights: ['Design exclusivo', 'Otimizado para Google (SEO)', 'Responsivo para celular'],
    image:
      'https://readdy.ai/api/search-image?query=vibrant%20colorful%20web%20design%20workspace%20with%20multiple%20monitors%20displaying%20bright%20colorful%20website%20UI%20mockups%20and%20design%20tools%2C%20creative%20designer%20desk%20with%20color%20swatches%20and%20wireframes%2C%20vivid%20orange%20yellow%20green%20and%20pink%20color%20palette%20on%20screens%2C%20modern%20creative%20studio%20environment%2C%20energetic%20and%20inspiring%20atmosphere%2C%20professional%20photography%20with%20warm%20colorful%20lighting&width=1200&height=600&seq=car007c&orientation=landscape',
    cta: 'Criar meu Site',
    color: '#00c9a7',
  },
];

interface ServicesCarouselProps {
  hero?: boolean;
}

export default function ServicesCarousel({ hero = false }: ServicesCarouselProps) {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');

  const goTo = useCallback(
    (index: number, dir: 'next' | 'prev' = 'next') => {
      if (isAnimating) return;
      setIsAnimating(true);
      setDirection(dir);
      setTimeout(() => {
        setCurrent(index);
        setIsAnimating(false);
      }, 350);
    },
    [isAnimating]
  );

  const next = useCallback(() => {
    goTo((current + 1) % slides.length, 'next');
  }, [current, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length, 'prev');
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 5500);
    return () => clearInterval(timer);
  }, [next]);

  const slide = slides[current];
  const whatsappBase = 'https://wa.me/5583991755663?text=';

  if (hero) {
    return (
      <section className="relative w-full min-h-screen overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 w-full h-full"
          style={{ opacity: isAnimating ? 0 : 1, transition: 'opacity 0.4s ease' }}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d1b2a]/97 via-[#0d1b2a]/85 to-[#0d1b2a]/60" />
          <div className="absolute inset-0 bg-[#0d1b2a]/40" />
        </div>

        {/* Content */}
        <div
          className="relative z-10 w-full min-h-screen flex flex-col justify-center pt-24 pb-32"
          style={{
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating
              ? direction === 'next' ? 'translateX(-40px)' : 'translateX(40px)'
              : 'translateX(0)',
            transition: 'opacity 0.4s ease, transform 0.4s ease',
          }}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-12 w-full flex flex-col items-center text-center">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-[#00c9a7]/20 border border-[#00c9a7]/40 text-[#00c9a7] text-xs font-semibold px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${slide.icon} text-sm`} />
              </div>
              {slide.tag}
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6 max-w-3xl">
              {slide.title}
            </h1>

            {/* Description */}
            <p className="text-white/90 text-base md:text-xl leading-relaxed mb-6 md:mb-8 max-w-2xl">
              {slide.description}
            </p>

            {/* Highlights */}
            <div className="flex flex-wrap justify-center gap-2 mb-8 md:mb-10">
              {slide.highlights.map((h) => (
                <span
                  key={h}
                  className="flex items-center gap-1.5 bg-white/10 text-white/90 text-xs md:text-sm font-medium px-3 md:px-4 py-1.5 md:py-2 rounded-full"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-[#00c9a7] text-xs" />
                  </div>
                  {h}
                </span>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <a
                href={`${whatsappBase}Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20de%20${encodeURIComponent(slide.title)}.`}
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-base" />
                </div>
                {slide.cta}
              </a>
              <Link
                to="/servicos"
                className="inline-flex items-center justify-center gap-2 bg-black/40 hover:bg-black/55 border border-white/70 hover:border-white text-white font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base backdrop-blur-md"
              >
                Ver todos os serviços
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom controls: arrows + dots */}
        <div className="absolute bottom-0 left-0 right-0 z-20 pb-6 md:pb-8">
          <div className="flex items-center justify-center gap-4 md:gap-6">
            {/* Prev arrow */}
            <button
              onClick={prev}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 hover:bg-[#00c9a7] border border-white/30 hover:border-[#00c9a7] text-white transition-all duration-200 cursor-pointer backdrop-blur-sm"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line text-lg" />
            </button>

            {/* Dots */}
            <div className="flex items-center gap-2">
              {slides.map((s, i) => (
                <button
                  key={s.tag}
                  onClick={() => goTo(i, i > current ? 'next' : 'prev')}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    i === current ? 'w-6 md:w-8 h-2 md:h-2.5 bg-[#00c9a7]' : 'w-2 md:w-2.5 h-2 md:h-2.5 bg-white/40 hover:bg-[#00c9a7]/60'
                  }`}
                  aria-label={`Ir para ${s.tag}`}
                />
              ))}
            </div>

            {/* Next arrow */}
            <button
              onClick={next}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 hover:bg-[#00c9a7] border border-white/30 hover:border-[#00c9a7] text-white transition-all duration-200 cursor-pointer backdrop-blur-sm"
              aria-label="Próximo"
            >
              <i className="ri-arrow-right-s-line text-lg" />
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 md:py-24 bg-[#f0faf8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 text-[#00c9a7] text-xs font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-px bg-[#00c9a7]" />
            Nossos Serviços
            <span className="w-8 h-px bg-[#00c9a7]" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-[#0d1b2a] mb-4">
            Soluções Completas em Tecnologia
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Do suporte técnico à criação de sites — temos tudo que você precisa para manter sua tecnologia funcionando.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden">
          {/* Slide */}
          <div
            className="relative w-full overflow-hidden"
            style={{ minHeight: '480px' }}
          >
            {/* Background Image */}
            <div
              className="absolute inset-0 w-full h-full"
              style={{
                opacity: isAnimating ? 0 : 1,
                transition: 'opacity 0.35s ease',
              }}
            >
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0d1b2a]/97 via-[#0d1b2a]/85 to-[#0d1b2a]/60" />
              <div className="absolute inset-0 bg-[#0d1b2a]/40" />
            </div>

            {/* Content */}
            <div
              className="relative z-10 flex items-center justify-center py-10 md:py-0 md:h-[420px]"
              style={{
                opacity: isAnimating ? 0 : 1,
                transform: isAnimating
                  ? direction === 'next'
                    ? 'translateX(-30px)'
                    : 'translateX(30px)'
                  : 'translateX(0)',
                transition: 'opacity 0.35s ease, transform 0.35s ease',
              }}
            >
              <div className="px-6 md:px-16 py-4 md:py-10 max-w-2xl w-full flex flex-col items-center text-center">
                {/* Tag */}
                <div className="inline-flex items-center gap-2 bg-[#00c9a7]/20 border border-[#00c9a7]/40 text-[#00c9a7] text-xs font-semibold px-3 py-1.5 rounded-full mb-4 md:mb-5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${slide.icon} text-sm`} />
                  </div>
                  {slide.tag}
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-4xl font-bold text-white mb-3 md:mb-4 leading-tight">
                  {slide.title}
                </h3>

                {/* Description */}
                <p className="text-white/90 text-sm md:text-base leading-relaxed mb-4 md:mb-6 max-w-lg">
                  {slide.description}
                </p>

                {/* Highlights */}
                <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-5 md:mb-8">
                  {slide.highlights.map((h) => (
                    <span
                      key={h}
                      className="flex items-center gap-1.5 bg-white/10 text-white/90 text-xs font-medium px-3 py-1.5 rounded-full"
                    >
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-check-line text-[#00c9a7] text-xs" />
                      </div>
                      {h}
                    </span>
                  ))}
                </div>

                {/* CTAs */}
                <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-2 md:gap-3">
                  <a
                    href={`${whatsappBase}Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20de%20${encodeURIComponent(slide.title)}.`}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-5 md:px-6 py-2.5 md:py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-xs md:text-sm"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-whatsapp-line text-sm" />
                    </div>
                    {slide.cta}
                  </a>
                  <Link
                    to="/servicos"
                    className="inline-flex items-center justify-center gap-2 bg-black/40 hover:bg-black/55 border border-white/70 hover:border-white text-white font-semibold px-5 md:px-6 py-2.5 md:py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-xs md:text-sm backdrop-blur-md"
                  >
                    Ver todos os serviços
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm" />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom controls: arrows + dots */}
        <div className="flex items-center justify-center gap-4 md:gap-6 mt-5 md:mt-7">
          {/* Prev arrow */}
          <button
            onClick={prev}
            className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-[#0d1b2a]/10 hover:bg-[#00c9a7] border border-gray-200 hover:border-[#00c9a7] text-[#0d1b2a] hover:text-white transition-all duration-200 cursor-pointer"
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-s-line text-lg" />
          </button>

          {/* Dots */}
          <div className="flex items-center gap-2">
            {slides.map((s, i) => (
              <button
                key={s.tag}
                onClick={() => goTo(i, i > current ? 'next' : 'prev')}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === current
                    ? 'w-6 md:w-8 h-2 md:h-2.5 bg-[#00c9a7]'
                    : 'w-2 md:w-2.5 h-2 md:h-2.5 bg-gray-300 hover:bg-[#00c9a7]/50'
                }`}
                aria-label={`Ir para ${s.tag}`}
              />
            ))}
          </div>

          {/* Next arrow */}
          <button
            onClick={next}
            className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-[#0d1b2a]/10 hover:bg-[#00c9a7] border border-gray-200 hover:border-[#00c9a7] text-[#0d1b2a] hover:text-white transition-all duration-200 cursor-pointer"
            aria-label="Próximo"
          >
            <i className="ri-arrow-right-s-line text-lg" />
          </button>
        </div>
      </div>
    </section>
  );
}
